import { Container, styled } from '@material-ui/core';

export const StyledDocument = styled(Container)(({ theme }) => ({
  '& .MuiTypography-h1': { marginTop: theme.spacing(7) },
  '& .MuiTypography-h2': { marginTop: theme.spacing(7) },
  '& .MuiTypography-h3': { marginTop: theme.spacing(7) },
  '& .MuiTypography-h4': { marginTop: theme.spacing(7) },
  '& .MuiTypography-h5': { marginTop: theme.spacing(7) },
  '& .MuiTypography-h6': { marginTop: theme.spacing(7) },
  '& p.MuiTypography-body1': { marginTop: theme.spacing(2) },
  '& p.MuiTypography-body2': { marginTop: theme.spacing(2) },

  '& .MuiLink-root': { color: '#1565c0' },

  '& .MuiList-root': {
    marginTop: theme.spacing(2),
    '& .MuiList-root:last-child': {
      marginBottom: theme.spacing(2),
    },
    '& ol.MuiList-root': {
      counterReset: 'item',
      listStyleType: 'none',
      paddingLeft: 0,
      '& .MuiListItem-root': {
        padding: 0,
        display: 'flex',
        alignItems: 'start',
        '&::before': {
          counterIncrement: 'item',
          content: '"(" counter(item) ") "',
          padding: '0 8px',
          marginTop: '-0.1em',
          fontSize: '14px',
          lineHeight: '21px',
        },
      },
    },
    '& ul.MuiList-root': {
      listStyle: 'circle',
    },
  },
  '& ol.MuiList-root': { listStyle: 'decimal' },
  '& ul.MuiList-root': { listStyle: 'disc' },
  '& .MuiList-padding': { padding: theme.spacing(0, 0, 0, 4) },
  '& .MuiListItem-root': {
    display: 'list-item',
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: theme.spacing(1),
    '&:first-child': { marginTop: 0 },
  },
  '& .MuiListItem-gutters': {
    paddingRight: 0,
    paddingLeft: theme.spacing(2),
  },
  '& .MuiListItemText-root': { margin: 0 },

  '& .MuiTable-root': {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  '& .MuiTableCell-root': {
    padding: theme.spacing(1.5, 1),
    borderBottom: '1px solid #7F7F7F',
    verticalAlign: 'top',
    color: '#333333',
    fontSize: '14px',
    lineHeight: '21px',
    [theme.breakpoints.up('lg')]: {
      minWidth: theme.spacing(20),
      maxWidth: theme.spacing(30),
    },
  },
  '& .MuiTableCell-root:first-child': {
    paddingLeft: theme.spacing(2),
    fontWeight: 'bold',
  },
  '& .MuiTableCell-root:last-child': { paddingRight: theme.spacing(2) },
  '& .MuiTableHead-root .MuiTableCell-root': {
    color: '#7F7F7F',
    fontWeight: 'bold',
  },
  '& .MuiTableBody-root': {
    borderTop: '2px solid #7F7F7F',
    borderBottom: '2px solid #7F7F7F',
  },
  '& > *:first-child': { marginTop: 0 },
}));
